import React from "react";
import styles from "../DressingChangeFrequency.module.scss";
import { plural } from "../utils/scheduleUtils";
import type { TimelineTick, Schedule } from "../types";

interface TimelineBarProps {
  ticks: TimelineTick[];
  schedule: Schedule;
}

export const TimelineBar: React.FC<TimelineBarProps> = ({ ticks, schedule }) => {
  if (ticks.length === 0) return null;

  const label =
    schedule.mode === "every"
      ? `Day 1 \u2014 starting 8:00 AM, then every ${plural(schedule.every, "hour")}`
      : "Each day \u2014 evenly spaced from 8:00 AM";

  return (
    <div className={styles.panel_column}>
      <span className={styles.panel_label}>{label}</span>
      <div className={styles.timeline_track}>
        {ticks.map((t, i) => (
          <span key={i} className={styles.timeline_tick} style={{ left: t.position }} />
        ))}
      </div>
      <div className={styles.timeline_axis}>
        <span>12 AM</span>
        <span>6 AM</span>
        <span>12 PM</span>
        <span>6 PM</span>
        <span>12 AM</span>
      </div>
    </div>
  );
};
